// extracted by mini-css-extract-plugin
module.exports = {"outerContainer":"ProjectBox1_outerContainer__28_6h","innerProjectHeader":"ProjectBox1_innerProjectHeader__7oJI1"};